import React, { useState } from 'react';

import { useSwipeable } from 'react-swipeable';

const Slider = React.memo(({ children, button, className }) => {
    const [currentChildIndex, setCurrentChildIndex] = useState(0);
    const currentChild = children[currentChildIndex];
    const ButtonComponent = button;
    const prev = () => {
        if (currentChildIndex === 0) {
            setCurrentChildIndex(children.length - 1);
        } else {
            setCurrentChildIndex(currentChildIndex - 1);
        }
    };
    const next = () => {
        if (currentChildIndex === children.length - 1) {
            setCurrentChildIndex(0);
        } else {
            setCurrentChildIndex(currentChildIndex + 1);
        }
    };
    const handlers = useSwipeable({
        onSwipedLeft: next,
        onSwipedRight: prev,
        preventDefaultTouchmoveEvent: true,
    });

    return (
        <div className={ className }>
            <div { ...handlers }>
                { currentChild }
            </div>
            { children.map((value, key) => {
                const isActive = key === currentChildIndex;
                return (
                    <ButtonComponent
                        key={ key }
                        index={ key }
                        isActive={ isActive }
                        onClick={ () => setCurrentChildIndex(key) }
                    />
                );
            }) }
        </div>
    );
});

export default Slider;
